var render = function render(){var _vm=this,_c=_vm._self._c;return _c('formulator-slide-and-select',{attrs:{"name":"Sal Mineral","unit":"%","min":"0","max":"8","interval":"0.1","info-modal":_vm.infoModal,"items":_vm.salts,"update-on-select":false,"keep-amount-on-select":""},model:{value:(_vm.salt),callback:function ($$v) {_vm.salt=$$v},expression:"salt"}})
}
var staticRenderFns = []

export { render, staticRenderFns }